import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { config } from 'config';

export interface FacilityCreateResponse {
  message?: string;
  email_error?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class FacilityService {
  constructor(private http: HttpClient) {}

  createFacility(facilityData: any): Observable<FacilityCreateResponse> {
    const payload = {
      facility_id: facilityData.facilityId,
      facility_name: facilityData.facilityName,
      referral_group_id: facilityData.referralGroup,
      practice_software: facilityData.practiceSoftware,
      emails: facilityData.emails,
      street_address: facilityData.streetAddress,
      city: facilityData.city,
      state: facilityData.state,
      postcode: facilityData.postcode,
      practice_manager_name: facilityData.practiceManagerName,
      practice_manager_email: facilityData.practiceManagerEmail,
      practice_manager_mobile: facilityData.practiceManagerMobile,
      it_technical_name: facilityData.itTechnicalName,
      it_technical_email: facilityData.itTechnicalEmail,
      it_technical_mobile: facilityData.itTechnicalMobile,
      referral_group_requester_name: facilityData.referralGroupRequesterName,
      referral_group_requester_email: facilityData.referralGroupRequesterEmail,
      referral_group_requester_phone: facilityData.referralGroupRequesterPhone,
      approved: facilityData.approved,
      performer_ids: facilityData.performer_ids || [],
      notes: facilityData.notes || '',
      account_manager_name: facilityData.accountManagerName || ''
    };
    const url = `${config.apiUrl1}facility/store`;
    return this.http.post<FacilityCreateResponse>(url, payload);
  }

  updateFacility(facilityId: number, facilityData: any): Observable<any> {
    console.log('Updating facility with ID:', facilityId, 'Data:', facilityData);
    const payload = {
      facilityID: facilityData.facilityId || facilityData.FacilityID || null,
      facility_name: facilityData.ClinicName || facilityData.facilityName,
      referral_group_id: facilityData.activeReferralGroupsID || facilityData.referralGroup,
      practice_software: facilityData.practiceSoftware,
      emails: facilityData.medicalClinicEmail || facilityData.emails,
      street_address: facilityData.streetAddress,
      city: facilityData.city,
      state: facilityData.state,
      postcode: facilityData.postcode,
      practice_manager_name: facilityData.practiceManagerName,
      practice_manager_email: facilityData.practiceManagerEmail,
      practice_manager_mobile: facilityData.practiceManagerMobile,
      it_technical_name: facilityData.itTechnicalName,
      it_technical_email: facilityData.itTechnicalEmail,
      it_technical_mobile: facilityData.itTechnicalMobile,
      referral_group_requester_name: facilityData.referralGroupRequesterName,
      referral_group_requester_email: facilityData.referralGroupRequesterEmail,
      referral_group_requester_phone: facilityData.referralGroupRequesterPhone,
      approved: facilityData.approved,
      performer_ids: facilityData.performer_ids || [],
      agreements : facilityData.agreements || {},
      notes: facilityData.notes || '',
      account_manager_name: facilityData.accountManagerName || ''
    };

    const url = `${config.apiUrl1}facility/update/${facilityId}`;
    return this.http.post<any>(url, payload);
  }

  acceptAgreementFacility(facilityId: number, facilityData: any): Observable<any> {
    const payload = {
      approved: facilityData.approved,
      agreements : facilityData.agreements || {}
    };

    const url = `${config.apiUrl1}facility/accept-agreement/${facilityId}`;
    return this.http.post<any>(url, payload);
  }

  getFacilityByHash(hash: string): Observable<any> {
    console.log('Fetching facility with hash:', hash);
    const url = `${config.apiUrl1}facility/get-by-hash/${hash}`;
    return this.http.get<any>(url);
  }

  approveFacility(payload: { facility_id: number }): Observable<any> {
    const url = `${config.apiUrl1}facility/approve-facility`;
    return this.http.post<any>(url, payload);
  }

  getReferralPerformers(payload: { referral_group_id: number, page?: number, per_page?: number, for_drop_down?: number }): Observable<any> {
    const url = `${config.apiUrl1}performer/get`;
    return this.http.get<any>(url, { params: payload } );
  }

  getReport(payload: { facility_id?: string, date_from?: string, date_to?: string, referral_group_id?: string }): Observable<any> {
    const url = `${config.apiUrl1}facility/report`;
    return this.http.post<any>(url, payload);
  }

  getActivity(payload: { id?: number, referral_group_id: string }): Observable<any> {
    const url = `${config.apiUrl1}facility/get-activity`;
    return this.http.post<any>(url, payload);
  }
}